import React from 'react';

import styles from './Promotions.module.scss';
import AppSwiper from "../AppSwiper/AppSwiper";

const Promotions = ({promotions = []}) => {
    return (
        <div className={styles.promotions_wrapper}>
            <div className={styles.promotions_wrapper_description}>
                <h2 className={styles.title}>Акції</h2>

                <p className={styles.subtitle}>
                    Спеціальні пропозиції та постійні знижки — оберіть акцію та отримайте промокод.
                </p>
            </div>

            <AppSwiper promotions={promotions}/>
        </div>
    );
};

export default Promotions;
